(function () {
    'use strict';

    /*
     * User Controller
     */

angular.module('ShargoApp')
    .service('UserService', function ($http, Configuration) {
        var svc = {};

        svc.getSender = function(){
            return $http.get(Configuration.apiUrl + '/senders/me', {
                headers: {
                    'x-token': localStorage.getItem('xtoken'),
                    'x-userid': localStorage.getItem('userid')
                }
            });
        };

        svc.registerSender = function (params) {
            return $http.post(Configuration.apiUrl + '/senders/register', params);
        };

        svc.restablishPass = function (params) {
            return $http.post(Configuration.apiUrl + '/password/forgot', params);
        };

        return svc;
    })

    .controller('UserController', function ($scope, $rootScope, $window, $location, AuthService, AUTH_EVENTS, toolsService, DeliversService, UserService) {
        /*  --VARIABLES-- */
        var previousPhone = "";
        $rootScope.user = {};

        $scope.user = {
            firstName: "",
            lastName: "",
            email: "",
            phone: ""
        };

        $scope.newUser = {
            firstName: "",
            lastName: "",
            email: "",
            password: "",
            phone: ""
        };

        $scope.restablishInfo = {
            email: "",
            done: false
        };

        $scope.show = {
            login: false,
            register: false,
            restablish: false,
            loginForced: false
        };

        $scope.errors = {
            register: {
                formNameErrorText: "",
                formPassErrorText: "",
                formPhoneErrorText: "",
                formEmailErrorText: ""
            },
            login: {
                formEmailErrorText: "",
                formPassErrorText: ""
            },
            restablish: {
                formErrorText: ""
            }
        };


        /*  --FUNCTIONS-- */
        function onlyNumbers(){
            if(!/^[0-9]*$/.test($scope.newUser.phone)) {
                $scope.newUser.phone = previousPhone;
            }
            else {
                previousPhone = $scope.newUser.phone;
            }
        }

        function showRegisterDialog(registerCase) {
            $rootScope.blur.userController = true;
            $scope.show.register = true;
            $scope.show.registerCase = (registerCase && !toolsService.isEmpty(registerCase.facebook)) ? registerCase : 'normal';
            $scope.show.login = false;
            $scope.show.restablish = false;

            toolsService.setFalse($scope.errors);
        }

        function showLoginDialog() {
            $rootScope.blur.userController = true;
            $scope.show.register = false;
            $scope.show.login = true;
            $scope.show.restablish = false;

            if($scope.show.registerCase && !toolsService.isEmpty($scope.show.registerCase.facebook)) {
                // setting to undefined to display again fb button on login form
                $scope.show.registerCase = undefined;
            }

            toolsService.setFalse($scope.errors);
        }

        function showRestablishDialog() {
            $scope.show.login = false;
            $scope.show.restablish = true;
            $scope.$apply();

            toolsService.setFalse($scope.errors);
        }

        function closeForms() {
            $scope.show = {
                login: false,
                register: false,
                restablish: false,
                loginForced: false
            };

            $rootScope.blur.userController = false;
        }

        function hideHeaderDialogs() {
			$scope.show.register = $scope.show.restablish = false;
			$rootScope.blur.userController = $scope.show.login = $scope.show.loginForced;
			$scope.show.loginForced = false;
        }

        function fbLogin() {
            FB.login(function(fbLoginResponse) {
                if(!toolsService.isEmpty(fbLoginResponse.authResponse)) {
                    if (fbLoginResponse.status === 'connected') {
                        // Logged into your app and Facebook.
                        var parameters = {
                            "fields" : "id, first_name, last_name, email"
                        };
                        FB.api('/me', 'get', parameters, function(meResponse) {
                            // {name: "Eric Lara", id: "10208609737788645"}
                            var facebookId = fbLoginResponse.authResponse.userID;
                            var params = {
                                facebookId: facebookId
                            };
                            AuthService.login(params).then(function (response) {
                                if(response.status == 200) {
                                    $rootScope.user = {
                                        firstName: response.data.firstName,
                                        lastName: response.data.lastName,
                                        email: response.data.email,
                                        phone: response.data.phone,
                                        referralUrl: response.data.referralUrl,
                                        popup: response.data.popup
                                    };
                                    $rootScope.$broadcast(AUTH_EVENTS.loginSuccess);
                                    $rootScope.isUserLogged = true;


                                    closeForms();
                                    $rootScope.$broadcast("regenerateHistory");
                                    $rootScope.pendingRating = false;

                                    DeliversService.shouldRate().then(function (res) {
                                        $rootScope.pendingRating = (res.data.shouldRate) && (!$scope.pageKey || !$scope.pageKey.name || $scope.pageKey.name !== 'dashboard');
                                    }).catch(function (error) {
                                        console.log("SHOULD RATE ERROR", error);
                                    });

                                    //$window.location.href = $rootScope.url('sendpackage');
									$location.path($rootScope.url('sendpackage'));
								}
                            }).catch(function (error) {
								$rootScope.$broadcast(AUTH_EVENTS.loginFailed);
                                if(error.status == 404) {
                                    // open register dialog with auto-filled fields, ready to send
                                    $scope.showRegisterDialog({'facebook': facebookId});
                                    if(!toolsService.isEmpty(meResponse.email)) {
                                        $scope.newUser.email = meResponse.email;
                                        if(!toolsService.isEmpty(meResponse.first_name)) {
                                            $scope.newUser.firstName = meResponse.first_name;
                                        }
                                        if(!toolsService.isEmpty(meResponse.last_name)) {
                                            if(!toolsService.isEmpty($scope.newUser.firstName)) {
                                                $scope.newUser.firstName += " ";
                                            }
                                            $scope.newUser.firstName += meResponse.last_name;
                                        }
                                    }
                                } else {
                                    // 403 show raw error message. Carrier is on wrong login form
									$scope.errors.login.formEmailErrorText = error.data.message;
                                    $rootScope.isUserLogged = false;
                                }
                            });
                        });
                    } else if (fbLoginResponse.status === 'not_authorized') {
                        // The person is logged into Facebook, but not your app.
                        console.log("The person is logged into Facebook, but not your app.");
                    } else {
                        // The person is not logged into Facebook, so we're not sure if
                        // they are logged into this app or not.
                        console.log("The person is not logged into Facebook, so we're not sure if they are logged into this app or not.");
                    }
                } else {
                    console.log("Case when user closed fb login pop-up without finish login");
                }
            }, {scope: 'public_profile,email'});
        }

        function register(form, registerCase, referral) {
            toolsService.setFalse($scope.errors);
            if (!form.email.$valid) {
                if(form.email.$error.required || form.email.$error.email) {
                    $scope.errors.register.formEmailErrorText = "dialogs.login.email-incorrect";
                }
            }
            if (!form.password.$valid) {
                if(form.password.$error.required || form.password.$error.minlength) {
                    $scope.errors.register.formPassErrorText = "dialogs.login.password-incorrect";
                }
            }
            if (!form.nombre.$valid) {
                if(form.nombre.$error.required) {
                    $scope.errors.register.formNameErrorText = "dialogs.login.name-incorrect";
                }
            }
            if (!form.phone.$valid || $scope.newUser.phone.length != "9") {
                if(form.phone.$error.required || $scope.newUser.phone.length != "9") {
                    $scope.errors.register.formPhoneErrorText = "dialogs.login.phone-incorrect";
                }
            }
            var passValidation = (registerCase && !toolsService.isEmpty(registerCase.facebook)) ? true : form.password.$valid;
            if (form.email.$valid && !$scope.errors.register.formPhoneErrorText && passValidation && form.nombre.$valid) {
                var params = {
                    firstName: $scope.newUser.firstName,
                    lastName: " ",//$scope.user.lastName,
                    password: $scope.newUser.password,
                    phone: $scope.newUser.phone,
                    email: $scope.newUser.email
                };

                if(registerCase && !toolsService.isEmpty(registerCase.facebook)) {
                    params.facebookId = registerCase.facebook;
                    delete params.password;
                    params.imageUrl = "https://graph.facebook.com/" + params.facebookId + "/picture?type=large";
                }

                if(referral && referral.code){
                    params.referralCode = referral.code;
                }

                UserService.registerSender(params)
                    .then(function(response) {
                        closeForms();

                        localStorage.setItem('userid', response.data._id);
                        localStorage.setItem('xtoken', response.data.authToken);
                        localStorage.setItem('firstName', response.data.firstName);
                        localStorage.setItem('lastName', response.data.lastName);
                        localStorage.setItem('type', "sender");

                        UserService.getSender()
                            .then(function(response) {
								$rootScope.user.firstName = response.data.firstName;
								$rootScope.user.lastName = response.data.lastName;
								$rootScope.user.email = response.data.email;
								$rootScope.user.phone = response.data.phone;
								$rootScope.user.imageUrl = response.data.imageUrl;
								$rootScope.user.referralUrl = response.data.referralUrl;
								$rootScope.user.popup = response.data.popup;
								$rootScope.pendingRating = false;
                                $rootScope.isUserLogged = true;

                                $rootScope.$broadcast("regenerateHistory");
                            }).catch(function(data) {
                            $rootScope.isUserLogged = false;
                        });

                        if(referral && referral.code && !$rootScope.device.isDesktop){
                            referral.registered = true;
                        }
                        else{
                            if(referral && referral.code){
								$rootScope.mgm.show.registered = true;
								$rootScope.blur.MGMPopUpregistered = true;
                            }
							$location.path($rootScope.url('sendpackage'));
                        }
					}).
                    catch(function (error) {
                        $scope.errors.register.formEmailErrorText = error.data.message;
                        $rootScope.isUserLogged = false;
                    });
            }
        }

		function login(form) {
			toolsService.setFalse($scope.errors);
			if (!form.email.$valid) {
				if(form.email.$error.required || form.email.$error.email) {
					$scope.errors.login.formEmailErrorText = "dialogs.login.email-incorrect";
				}
			}
			if (!form.password.$valid) {
				if(form.password.$error.required || form.password.$error.minlength) {
					$scope.errors.login.formPassErrorText = "dialogs.login.password-incorrect";
				}
			}
			if (form.email.$valid && form.password.$valid) {
				var params = {
					password: $scope.user.password,
					email: $scope.user.email
				};

				AuthService.login(params)
				.then(function (response) {
					$rootScope.$broadcast(AUTH_EVENTS.loginSuccess);//TODO
					$rootScope.user.firstName = response.data.firstName;
					$rootScope.user.lastName = response.data.lastName;
					$rootScope.user.email = response.data.email;
					$rootScope.user.phone = response.data.phone;
					$rootScope.user.imageUrl = response.data.imageUrl;
					$rootScope.user.referralUrl = response.data.referralUrl;
					$rootScope.user.popup = response.data.popup;
					$rootScope.isUserLogged = true;
					closeForms();

					$rootScope.$broadcast("regenerateHistory");
					$rootScope.pendingRating = false;

					DeliversService.shouldRate().then(function (res) {
						$rootScope.pendingRating = (res.data.shouldRate) && (!$scope.pageKey || !$scope.pageKey.name || $scope.pageKey.name !== 'dashboard');
					}).catch(function (error) {
						console.log("SHOULD RATE ERROR", error);
					});

					if (AuthService.isDriver()) {
						$window.location.href = $rootScope.url('driver-profile');
					}
                    else {
						if (response.data.referralUrl){
							$rootScope.clipboardTextButton = response.data.referralUrl.substr(response.data.referralUrl.indexOf("shargo.io"));
						}
						if(response.data.popup.mgmCompletedGuest){
							$rootScope.mgm.show.promotion = "refered"; //"refered" "invitation"
							$rootScope.blur.MGMPopUppromotion = true;
						}
						else if (response.data.popup.mgmCompletedHost.length > 0){
					    	$rootScope.mgm.list = response.data.popup.mgmCompletedHost;
					    	$rootScope.mgm.index = 0;
							$rootScope.mgm.show.promotion = "referral"; //"refered" "invitation"
							$rootScope.blur.MGMPopUppromotion = true;
                        }

						//$window.location.href = $rootScope.url('sendpackage');
                        $location.path($rootScope.url('sendpackage'));
					}
				}).catch(function (error) {
					$rootScope.$broadcast(AUTH_EVENTS.loginFailed);
					$scope.errors.login.formEmailErrorText = error.data.message;
					$rootScope.isUserLogged = false;
				});
			}
		}

        function recover(form) {
            toolsService.setFalse($scope.errors);
            if (!form.email.$valid) {
                if(form.email.$error.required || form.email.$error.email) {
                    $scope.errors.restablish.formErrorText = "dialogs.login.email-incorrect";
                }
            }
            else {
                var params = {
                    email: $scope.restablishInfo.email
                };

                UserService.restablishPass(params)
                    .then(function (response) {
                        $scope.restablishInfo.done = true;
                    })
					.catch(function (error) {
                    	$scope.errors.restablish.formErrorText = error.data.message;
                	});
            }
        }

        function restablished() {
            $scope.restablishInfo.done = false;
            closeForms();
        }

        /*  --EXECUTION--  */
        $scope.onlyNumbers = onlyNumbers;
        $scope.showRegisterDialog = showRegisterDialog;
        $scope.showLoginDialog = showLoginDialog;
        $scope.showRestablishDialog = showRestablishDialog;
        $scope.closeForms = closeForms;
        $scope.hideHeaderDialogs = hideHeaderDialogs;
        $scope.fbLogin = fbLogin;
        $scope.register = register;
        $scope.login = login;
        $scope.recover = recover;
        $scope.restablished = restablished;

        $rootScope.$on("showLoginDialog", function () {
			$rootScope.blur.userController = true;
			$scope.show.register = false;
			$scope.show.login = true;
			$scope.show.restablish = false;
			$scope.show.loginForced = true;

			if($scope.show.registerCase && !toolsService.isEmpty($scope.show.registerCase.facebook)) {
				// setting to undefined to display again fb button on login form
				$scope.show.registerCase = undefined;
			}

			toolsService.setFalse($scope.errors);
		});

        if(AuthService.isSender()) {
          UserService.getSender()
                .then(function successCallback(response) {
					$rootScope.user.firstName = response.data.firstName;
					$rootScope.user.lastName = response.data.lastName;
					$rootScope.user.email = response.data.email;
					$rootScope.user.phone = response.data.phone;
					$rootScope.user.imageUrl = response.data.imageUrl;
					$rootScope.user.referralUrl = response.data.referralUrl;
                    $rootScope.user.popup = response.data.popup;
                    $rootScope.isUserLogged = true;

                    $rootScope.$broadcast("regenerateHistory");
                    $rootScope.pendingRating = false;

                    DeliversService.shouldRate().then(function (res) {
                        $rootScope.pendingRating = (res.data.shouldRate) && (!$scope.pageKey || !$scope.pageKey.name || $scope.pageKey.name !== 'dashboard');
                    }).catch(function (error) {
                        console.log("SHOULD RATE ERROR", error);
                    });

                    if (response.data.referralUrl){
						$rootScope.clipboardTextButton = response.data.referralUrl.substr(response.data.referralUrl.indexOf("shargo.io"));
					}
					if(response.data.popup.mgmCompletedGuest){
						$rootScope.mgm.show.promotion = "refered"; //"refered" "invitation"
						$rootScope.blur.MGMPopUppromotion = true;
					}
					else if(response.data.popup.mgmCompletedHost.length > 0){
						$rootScope.mgm.list = response.data.popup.mgmCompletedHost;
						$rootScope.mgm.index = 0;
						$rootScope.mgm.show.promotion = "referral"; //"refered" "invitation"
						$rootScope.blur.MGMPopUppromotion = true;
					}

                }, function errorCallback(data) {
                    $rootScope.isUserLogged = false;
                });
        }
    });
})();